var map = {
	"./cat-1.svg": "f16f",
	"./cat-2.svg": "b208",
	"./cat-3.svg": "f031",
	"./cat-banner-catalogue.svg": "7c78",
	"./cat-banner.svg": "0dba",
	"./com-1.svg": "0024",
	"./com-2.svg": "2238",
	"./com-3.svg": "073b",
	"./com-banner-catalogue.svg": "818f",
	"./com-banner.svg": "e5f7",
	"./edu-1.svg": "55f4",
	"./edu-2.svg": "5c53",
	"./edu-3.svg": "688f",
	"./edu-banner-catalogue.svg": "359c",
	"./edu-banner.svg": "df7a",
	"./esport-1.svg": "e3de",
	"./esport-2.svg": "bd19",
	"./esport-3.svg": "cdca",
	"./esport-banner-catalogue.svg": "2575",
	"./esport-banner.svg": "df67",
	"./fs-1.svg": "5e80",
	"./fs-2.svg": "fe93",
	"./fs-3.svg": "03e1",
	"./fs-banner-catalogue.svg": "c669",
	"./fs-banner.svg": "ecf3",
	"./health-1.svg": "170c",
	"./health-2.svg": "4f79",
	"./health-3.svg": "54fa",
	"./health-banner-catalogue.svg": "6312",
	"./health-banner.svg": "dc43",
	"./ins-1.svg": "8ab4",
	"./ins-2.svg": "1899",
	"./ins-3.svg": "67a0",
	"./ins-banner-catalogue.svg": "5f0d",
	"./ins-banner.svg": "3561",
	"./tour-1.svg": "3e84",
	"./tour-2.svg": "d7b9",
	"./tour-3.svg": "da23",
	"./tour-banner-catalogue.svg": "1010",
	"./tour-banner.svg": "a097"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c17";